import { useState, useEffect } from 'react';
import { supabase, TABLES } from '../utils/supabase';
import type { TokenData } from '../types';

// Hook to fetch ALL tokens for profile lookups and other use cases
export const useAllTokens = () => {
  const [allTokens, setAllTokens] = useState<TokenData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchAllTokens = async () => {
    try {
      setLoading(true);
      setError(null);
      
      console.log('🔍 [useAllTokens] Fetching ALL tokens for profile lookup...');

      // Get ALL tokens from the database (no pagination limit)
      const { data, error: fetchError } = await supabase
        .from(TABLES.TOKENS)
        .select('*')
        .eq('network', 'ink')
        .order('created_at', { ascending: false });

      if (fetchError) {
        throw new Error(fetchError.message);
      }

      console.log('🔍 [useAllTokens] Fetched ALL tokens:', { 
        totalCount: data?.length || 0,
        sample: data?.slice(0, 5).map(t => ({ 
          name: t.name, 
          symbol: t.symbol,
          deployer: t.deployer_address, 
          contract: t.contract_address,
          created: t.created_at 
        })) || []
      });

      setAllTokens(data || []);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch all tokens';
      console.error('❌ [useAllTokens] Error:', errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllTokens();
  }, []);

  return {
    allTokens,
    loading,
    error,
    refetch: fetchAllTokens
  };
};
